import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change (pathname change), scroll to the top of the page.
 *
 * If Lenis (smooth-scroll) is active it manages window scroll via rAF, so
 * `window.scrollTo` can be overridden mid-frame. We use Lenis's own
 * `scrollTo(0, { immediate: true })` when available for a guaranteed jump.
 *
 * If the URL contains a hash (#book, #portfolio, etc.), let the target
 * page's own hash-scroll handler take over — don't fight it.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;

    const lenis = typeof window !== "undefined" ? window.__lenis : null;
    if (lenis && typeof lenis.scrollTo === "function") {
      // Immediate jump — no easing — so the visitor lands at the top cleanly
      lenis.scrollTo(0, { immediate: true, force: true });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
